export interface IDefault {
  _id: string;
  createdAt: string;
  updatedAt: string;
}

export enum AccessControl {
  SUBSCRIBER = "SUBSCRIBER",
  ORGANISATION = "ORGANISATION",
  // GYM = "GYM",
  GLOBAL = "GLOBAL",
}

